import React, { useState, useEffect } from "react";
import { Text } from "../../formitems/Index";
import {
  clients,
  Fleets,
  SubCatagory,
  Phase,
  phases,
  deleteAircrafts,
  AircraftFormSubmit,
  Update_Aircraft_Form,
} from "../../../Queries/AircraftQuery/AirCraftQuery";
import { useQuery, useMutation } from "@apollo/client";
import { Select, Switch, InputNumber } from "antd";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ReactHtmlParser from "react-html-parser";
import AircraftPhases from "./AircraftPhases";

const AircraftForm = () => {
  const [dropdown2, setdropdown2] = useState("");
  const [dropdown4, setdropdown4] = useState("");
  const [value, setval] = useState("");
  const [dropdown5, setdropdown5] = useState("");
  const [dropdown, setdropdown] = useState("");
  const [name, setname] = useState("");
  const [validity, setvalidity] = useState(30);
  const [toggle, settoggle] = useState(false);
  const [toggle3, settoggle3] = useState(false);
  const [toggle4, settoggle4] = useState(false);
  const [richtexttoggle, setrichtexttoggle] = useState(false);
  const [toggle5, settoggle5] = useState(false);
  const { data: AircraftForm } = useQuery(phases, {
    variables: {
      clientId: dropdown2[1],
      fleetsid: dropdown[1],
      phaseid: dropdown5,
    },
  });
  const { data } = useQuery(clients);
  const { data: dataa } = useQuery(Fleets, {
    variables: { Id: dropdown2[1] },
  });
  const [Cencel_Aircraft, { dataaaa }] = useMutation(deleteAircrafts);
  const [SubmitAircraft, { data: Aircraft }] = useMutation(AircraftFormSubmit);
  const [Update_Aircraft_Forms, { dataaaaaa }] = useMutation(
    Update_Aircraft_Form
  );
  const { data: phasess } = useQuery(Phase);
  const { data: catagory } = useQuery(SubCatagory);
  const Option = Select.Option;

  useEffect(() => {
    const add_Aircraft = (i) => {
      console.log(i);
      if (i !== undefined) {
        Update_Aircraft_Forms({
          variables: { id: i, name: name },
        });
      }
    };
    if (Aircraft !== undefined) {
      add_Aircraft(
        Aircraft?.insert_aatmsv4_aircraftforms?.returning[0].aircraftformid
      );
    }
  }, [Aircraft]);

  function onChange(value) {
    setvalidity(value);
  }
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true);
  };
  const togle3 = () => {
    toggle3 ? settoggle3(false) : settoggle3(true);
  };
  const togle4 = () => {
    toggle4 ? settoggle4(false) : settoggle4(true);
  };
  const togle5 = () => {
    toggle5 ? settoggle5(false) : settoggle5(true);
  };
  const togle2 = () => {
    richtexttoggle ? setrichtexttoggle(false) : setrichtexttoggle(true);
  };
  const handlerOnChange = (e, editor) => {
    const data = editor.getData();
    setval(data);
  };
  return (
    <div className="animate__animated animate__fadeIn">
      {toggle ? (
        <div className="category-title">Phase: {dropdown5}</div>
      ) : (
        <div className="category-title">Aircraft Form</div>
      )}
      <div className={toggle || richtexttoggle ? "hide-element" : ""}>
        <div className="toggle-form-container">
          <Select
            defaultValue="Select Client"
            onChange={(e) => setdropdown2(e)}
          >
            {data?.aatmsv4_clients?.map((el, i) => (
              <Option key={i} value={[el.clientname, el.clientsid]}>
                {el.clientname}
              </Option>
            ))}
          </Select>
          <Select defaultValue="Select Fleet" onChange={(e) => setdropdown(e)}>
            {dataa?.aatmsv4_fleets?.map((el, i) => (
              <Option key={i} value={[el.aircraft, el.fleetsid]}>
                {el.aircraft}
              </Option>
            ))}
          </Select>
          <div>
            Validity <span style={{ color: "burlywood" }}>(30 to 9999)</span>
          </div>
          <InputNumber
            size="large"
            style={{ width: "300px" }}
            min={30}
            max={9999}
            defaultValue={validity}
            onChange={onChange}
          />
          <br />
          <br />
          <Text title="Category" value="Aircraft" disabled />
          <Select
            defaultValue="Sub Catagories"
            onChange={(e) => setdropdown4(e)}
          >
            {catagory?.aatmsv4_subcategory?.map((el, i) => (
              <Option key={i} value={el.subcategoryid}>
                {el.subcategoryid}
              </Option>
            ))}
          </Select>
          <Text
            title="Name of the line training"
            value={name}
            onChange={(e) => setname(e.target.value)}
          />

          <div className={toggle || richtexttoggle ? "hide-element" : ""}>
            <button
              className="submit-button"
              onClick={() => {
                SubmitAircraft({
                  variables: {
                    clientsid: dropdown2[1],
                    clientname: dropdown2[0],
                    fleetsid: dropdown[1],
                    validit: validity,
                    subcategory: dropdown4,
                    aircraftformname: name,
                    ntc: toggle3,
                    remarks: toggle4,
                    result: toggle5,
                    reginfo: value,
                  },
                });
                setTimeout(() => {
                  setdropdown4("");
                  setdropdown2("");
                  setdropdown("");
                  setvalidity(30);
                  setval("");
                  setname("");
                }, 2000);
              }}
            >
              Publish Form
            </button>
            <button className="preview-button">
              <i className="fa fa-eye" />
              Preview
            </button>
            <button
              className="cancel-button"
              onClick={() => {
                Cencel_Aircraft();
              }}
            >
              Cancel
            </button>
          </div>
          {name ? (
            <div>
              <div>Add Technical Competency</div>
              <Switch onClick={togle} /> <br /> <br />
              <div>Add Non Technical Competency</div>
              <Switch onClick={togle3} />
              <br />
              <br />
              <div>Add Remarks Section</div>
              <Switch onClick={togle4} /> <br /> <br />
              <div>Add Result Section</div>
              <Switch onClick={togle5} />
              <br />
              <br />
              <div>Add Regulatory Information Section</div>
              <Switch onClick={togle2} />
            </div>
          ) : null}
        </div>
      </div>
      <div className={"" + (toggle || richtexttoggle ? "" : "hide-element")}>
        {toggle ? (
          <div>
            <Select
              defaultValue="Select Phases"
              onChange={(e) => setdropdown5(e)}
            >
              {phasess?.aatmsv4_phase?.map((el, i) => (
                <Option key={i} value={el.phaseid}>
                  {el.phaseid}
                </Option>
              ))}
            </Select>
          </div>
        ) : null}
        <div>
          {toggle ? (
            <AircraftPhases
              data={AircraftForm}
              phase={dropdown5}
              name={name}
              togglee={settoggle}
            />
          ) : null}
          {/* rich text */}
          {richtexttoggle ? (
            <div>
              <CKEditor editor={ClassicEditor} onChange={handlerOnChange} />
              <div>{ReactHtmlParser(value)}</div>
              <button
                className="cancel-button"
                onClick={() => setrichtexttoggle(false)}
              >
                Done
              </button>
            </div>
          ) : null}
        </div>
      </div>
      {/* add new */}
    </div>
  );
};

export default AircraftForm;
